import { Suspense } from "react";

import { useIntl } from "react-intl";

import { LANGUAGE_ID } from "../../../../shared/lang/lang.constants";

import { CfLoader } from "../../../../shared/components/common/CfLoader/CfLoader";
import DynamicIntlProvider from "../../../../shared/components/DynamicIntlProvider/DynamicIntlProvider";
import { BaseContainer } from "../../../../shared/containers/BaseContainer/BaseContainer";
import { usePageTitle } from "../../../../shared/hooks/usePageTitle";
import Localization from "../../../../shared/services/Localization.service";
import { Login } from "../Login/Login";

const LoginContent = () => {
  const intl = useIntl();
  usePageTitle(intl.formatMessage({ id: "Login.cleverfarm-login" }));

  return (
    <Suspense fallback={<CfLoader />}>
      <Login />
    </Suspense>
  );
};

const LoginWrapper = () => {
  const langId = Localization.getLang() as LANGUAGE_ID;

  return (
    <DynamicIntlProvider locale={langId}>
      <BaseContainer>
        <LoginContent />
      </BaseContainer>
    </DynamicIntlProvider>
  );
};

// eslint-disable-next-line import/no-default-export
export default LoginWrapper;
